var config = {
  // baseUrl: 'http://192.168.1.33:12300/',
  baseUrl: 'https://oa.mzyc.cn/',
  // filePreview: 'http://192.168.1.82:8012/onlinePreview'
  filePreview: 'https://oa.mzyc.cn/preview/onlinePreview'
};
export default config;